<template>
    <div class="sales-card-about">
        <div class="column-container">
            <div class="col-left">
                <div class="sales-card-section-title"><h2>{{ salesCardArr.project_page_in.about_title  }}</h2></div>
                <div class="about-desc" v-html="salesCardArr.project_page_in.about_desc"></div>
            </div>
            <div class="col-right">
                <div class="about-adres"><p v-html="salesCardArr.project_page_in.about_adres"></p></div>
                <div class="about-district">
                    <span v-if="globalLang == ''">{{ salesCardArr.project_page_in.about_location.name }} район</span>
                    <span v-if="globalLang == 'kz/'">{{ salesCardArr.project_page_in.about_location.name }} ауданы</span>
                </div>
                <div class="about-key-info">
                    <div class="key-item">
                        <div class="num">{{ salesCardArr.project_page_in.about_params.floor.min }}-{{ salesCardArr.project_page_in.about_params.floor.max }}</div>
                        <span>{{ salesCardArr.project_page_in.about_params.floor.name }}</span>
                    </div>
                    <div class="key-item">
                        <div class="num">{{ salesCardArr.project_page_in.about_params.size.min }}-{{ salesCardArr.project_page_in.about_params.size.max }} м²</div>
                        <span>{{ salesCardArr.project_page_in.about_params.size.name }}</span>
                    </div>
                    <div class="key-item">
                        <div class="num">{{ salesCardArr.project_page_in.about_params.up.height }} м</div>
                        <span>{{ salesCardArr.project_page_in.about_params.up.name }}</span>
                    </div>
                </div>
                <div class="btns-items">
                    <router-link class="btn-item link-to-flats" to="/flats">
                        <span>{{ salesCardArr.project_page_in.setup_flats_btn }}</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </router-link>
                    <div class="btn-item  btn-consult" @click="openContactsFormModal('call-page-get', cardID, 'Блок о проекте')">
                        <span v-if="globalLang != 'kz/'">Оставить заявку</span>
                        <span v-else>Өтінім қалдыру</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'sales-card-about',
        props: ['salesCardArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                cardID: this.$route.params.id,
            }
        },
        computed: mapGetters({
            // indexPage: 'loadIndexPage',
        }),
        methods: {
            openContactsFormModal(param, page, block) {
                this.$store.commit('formGlobalParam_set', param);
                this.$store.commit('formGlobalDataModal_set', {'page' : page, 'block' : block});
                this.$store.commit('formModalContainerOpen');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-about.scss';
    @import '@/styles/components/sales-card/respond/sales-card-about-respond.scss';
</style>